var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"stroke":"currentColor","strokeWidth":"1.25","d":"M1.42.625h10.113c.442 0 .8.358.8.8V20.58c0 .442-.358.8-.8.8H1.423c-.442 0-.8-.358-.8-.8V1.42c0-.21.084-.414.234-.563.15-.15.352-.233.563-.232z","key":0}),React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M7.12 17.75c0 .35-.21.666-.532.8-.323.133-.695.06-.942-.188-.247-.247-.32-.62-.187-.942.132-.322.448-.533.797-.533.477 0 .864.387.864.864","key":1})]));
}

Phone.defaultProps = {"width":"14","height":"24","viewBox":"-1 -1 14 24"};

module.exports = Phone;

Phone.default = Phone;
